import { render, staticRenderFns } from "./AdminSubjectChanger.vue?vue&type=template&id=32894508"
import script from "./AdminSubjectChanger.vue?vue&type=script&lang=js"
export * from "./AdminSubjectChanger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports